import { Helmet } from 'react-helmet';
import usePWABranding from '../../hooks/usePWABranding';

/**
 * Injects tenant PWA branding into document head for Apple / iOS and theme-color.
 * Link previews (og:* / twitter:*) vêm do HTML inicial gerado no build (vite inject-og-meta);
 * não duplicar aqui — crawlers não executam React.
 *
 * Não use `blob:` ou `data:` em `link[rel="manifest"]`: o Chromium (especialmente Android)
 * não trata isso como manifest instalável e o evento `beforeinstallprompt` deixa de disparar.
 * O manifest permanece o de `index.html` / `/manifest.webmanifest` (ou URL do backend).
 */
export default function PwaHeadUpdater() {
  const { displayName, iconUrl, appleTouchIconUrl, themeColor, loaded } = usePWABranding();

  const appleTitle = displayName || undefined;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const appleIconHref = appleTouchIconUrl || iconUrl || `${origin}/icons/icon-192.png`;
  const themeColorContent = themeColor || '#000000';

  if (!loaded) return null;

  return (
    <Helmet>
      {appleTitle && <meta name="apple-mobile-web-app-title" content={appleTitle} />}
      <link rel="apple-touch-icon" href={appleIconHref} />
      <meta name="theme-color" content={themeColorContent} />
    </Helmet>
  );
}
